import { useEffect } from "react";
import { eventBus } from "./eventBus.js";
export default (eventName, listener) => {
  useEffect(() => {
    eventBus.on(eventName, listener);
    return () => {
      eventBus.off(eventName, listener);
    };
  }, [eventName, listener]);
};